import request from '#/utils/request';
import { parseLoginResponse } from '#/api/adapters/envelope';

/**
 * 登出 API — 需 Bearer token。
 * @see docs/API_AUTH.md
 */
export async function logout() {
  const { data: raw } = await request.post('/auth/logout', {}, {
    skipSessionExit: true,
  });
  return parseLoginResponse(raw);
}
